import { QUES_COMPONENT_TYPES } from '../componentTypes';

export default [
  {
    sequenceNumber: 28,
    content:
      'To what extent will other corporate initiatives that exist compete for resources that could impact decisions and outcomes expected from the deal?',
    type: QUES_COMPONENT_TYPES.EXECUTION,
    subTitle: 'Corporate Initiatives',
    compLocation: 'down',
    options: {
      type: '28',
      radioText: [
        { text: 'Minimal Impact' },
        { text: 'Minor Impact' },
        { text: 'Moderate Impact' },
        { text: 'Major Impact' },
        { text: 'Significant Impact' },
      ],
    },
  },
  {
    sequenceNumber: 29,
    content: 'What is the expected degree of integration?',
    type: QUES_COMPONENT_TYPES.EXECUTION,
    compLocation: 'up',
    subTitle: 'Degree of Integration',
    options: {
      type: '29',
      radioText: [{ text: 'Minimal' }, { text: 'Partial' }, { text: 'Full' }],
    },
  },

  {
    sequenceNumber: 30,
    content:
      'Has a dedicated transaction leader been identified / appointed to lead the overall effort?',
    type: QUES_COMPONENT_TYPES.EXECUTION,
    subTitle: 'Dedicated Transaction Leader',
    options: {
      type: '30',
      radioText: [{ text: 'Yes' }, { text: 'No' }],
    },
  },

  {
    sequenceNumber: 31,
    content:
      'What resource capacity does the acquiring organization have to allocate towards deal planning and execution?',
    type: QUES_COMPONENT_TYPES.EXECUTION,
    subTitle: 'Resource Capacity',
    options: {
      type: '31',
      radioText: [
        { text: 'Significant' },
        { text: 'Moderate' },
        { text: 'Minimal' },
      ],
    },
  },
  {
    sequenceNumber: 32,
    content:
      'What are the primary ERP applications used by the Buyer / Target?',
    type: QUES_COMPONENT_TYPES.EXECUTION,
    isCollapse: true,
    compLocation: 'up',
    options: {
      type: '32',
      radioText: [
        { text: 'On-premise' },
        { text: 'Cloud' },
        { text: 'Unknown' },
      ],
      checkerText: [
        { text: 'Not supported by vendor' },
        { text: 'Material level of customization' },
      ],
    },
    isBPSI: true,
  },
  {
    sequenceNumber: 33,
    content:
      'What are the primary CRM applications used by the Buyer / Target?',
    type: QUES_COMPONENT_TYPES.EXECUTION,
    isCollapse: true,
    options: {
      type: '33',
      radioText: [
        { text: 'On-premise' },
        { text: 'Cloud' },
        { text: 'Unknown' },
      ],
      checkerText: [
        { text: 'Not supported by vendor' },
        { text: 'Material level of customization' },
      ],
    },
    isBPSI: true,
  },
  {
    sequenceNumber: 34,
    content:
      'What are the primary HCM applications used by the Buyer / Target?',
    type: QUES_COMPONENT_TYPES.EXECUTION,
    isCollapse: true,
    options: {
      type: '34',
      radioText: [
        { text: 'On-premise' },
        { text: 'Cloud' },
        { text: 'Unknown' },
      ],
      checkerText: [
        { text: 'Not supported by vendor' },
        { text: 'Material level of customization' },
      ],
    },
    isBPSI: true,
  },

  {
    sequenceNumber: 35,
    content:
      'What is the primary marketing automation application used by the Buyer/Target?',
    type: QUES_COMPONENT_TYPES.EXECUTION,
    isCollapse: true,
    isBPSI: true,
    options: {
      type: '35',
      radioText: [
        { text: 'On-premise' },
        { text: 'Cloud' },
        { text: 'Unknown' },
      ],
      checkerText: [
        { text: 'Not supported by vendor' },
        { text: 'Material level of customization' },
      ],
    },
  },
  {
    sequenceNumber: 36,
    content: 'What is the primary SCM application used by the Buyer/Target?',
    type: QUES_COMPONENT_TYPES.EXECUTION,
    isCollapse: true,
    isBPSI: true,
    options: {
      type: '36',
      radioText: [
        { text: 'On-premise' },
        { text: 'Cloud' },
        { text: 'Unknown' },
      ],
      checkerText: [
        { text: 'Not supported by vendor' },
        { text: 'Material level of customization' },
      ],
    },
  },
  {
    sequenceNumber: 37,
    content:
      'What level of experience does the Buyer have doing a deal of this size, scope and type?',
    type: QUES_COMPONENT_TYPES.EXECUTION,

    subTitle: 'Integration Experience',
    options: {
      type: '37',
      radioText: [
        { text: 'Significant (> 3 deals over the past 5 years)' },
        { text: 'Moderate (1-3 deals over the past 5 years)' },
        { text: 'Limited (0 deals over the past 5 years)' },
      ],
    },
  },
  // {
  //   content:
  //     'Are the Buyer and Target in the same industry?',
  //   type: QUES_COMPONENT_TYPES.EXECUTION,
  //   options: { type: 'SCM' },
  // },
  // {
  //   content: 'What is the level of customer overlap for the buyer and Target?',
  //   type: QUES_COMPONENT_TYPES.EXECUTION,
  //   options: { type: 'OverLap' },
  // },
  // {
  //   content:
  //     'Understanding level of customer overlap, how much of the deal value is tied to the customer integration strategy?',
  //   type: QUES_COMPONENT_TYPES.EXECUTION,
  //   options: { type: 'OverLap' },
  // },
];
